
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-36143fb2&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ItalianEInvoiceSplitPaymentConfiguration.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ItalianEInvoiceSplitPaymentConfiguration.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-36143fb2!../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ItalianEInvoiceSplitPaymentConfiguration.vue"),
  /* scopeId */
  "data-v-36143fb2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/backoffice/configuration/ItalianEInvoiceSplitPaymentConfiguration.vue
// module id = 1962
// module chunks = 1